import { SgvJson } from '@eceos/arch';
import { EceosValidatorsUtils } from '@eceos/common-utils';
import { CalculatedValue } from '../../calculated-value';

export interface PisValueWithAliquotHolder {
  pis: PisValueWithAliquot;
}

export abstract class PisValueWithAliquot {
  constructor(
    public aliquot: number = null,
    public value: CalculatedValue = new CalculatedValue()
  ) {}

  abstract isValid(): boolean;

  abstract toJson(): any;

  static fromJson(json: any): PisValueWithAliquot {
    if (json && json.type) {
      switch (json.type) {
        case 'percent':
          return PisValueWithAliquotPercent.fromJson(json);
        case 'value':
          return PisValueWithAliquotValue.fromJson(json);
        default:
          return null;
      }
    }
    return null;
  }
}

export class PisValueWithAliquotPercent extends PisValueWithAliquot {
  constructor(aliquot: number = null, value = new CalculatedValue()) {
    super(aliquot, value);
  }

  isValid(): boolean {
    return this.aliquot != null && EceosValidatorsUtils.isValid(this.value);
  }

  toJson(): any {
    return SgvJson.to.simple(this, {
      type: 'percent',
      value: this.value ? this.value.toJson() : null
    });
  }

  static fromJson(json: any): PisValueWithAliquotPercent {
    return json
      ? SgvJson.from.simple(json, PisValueWithAliquotPercent, {
          value: CalculatedValue.fromJson(json.value)
        })
      : null;
  }
}

export class PisValueWithAliquotValue extends PisValueWithAliquot {
  constructor(
    aliquot: number = null,
    value = new CalculatedValue(),
    public productQuantity: number = null
  ) {
    super(aliquot, value);
  }

  calcValue(): number {
    const value = this.productQuantity * this.aliquot;
    return isNaN(value) ? null : value;
  }

  isValid(): boolean {
    return (
      this.aliquot != null &&
      EceosValidatorsUtils.isValid(this.value) &&
      this.productQuantity != null
    );
  }

  publishValues(): PisValueWithAliquotValue {
    this.value.value = this.calcValue();
    return this;
  }

  toJson(): any {
    return SgvJson.to.simple(this, {
      type: 'value',
      value: this.value ? this.value.toJson() : null
    });
  }

  static fromJson(json: any): PisValueWithAliquotValue {
    return json
      ? SgvJson.from.simple(json, PisValueWithAliquotValue, {
          value: CalculatedValue.fromJson(json.value)
        })
      : null;
  }
}
